const PAGE_SIZE_OPTIONS = [25, 50, 100]

type Props = {
  value: number
  onChange: (size: number) => void
}

const PageSizeSelect = ({ value, onChange }: Props) => (
  <select
    className="form-control"
    style={{ width: 'auto' }}
    value={value}
    onChange={(e) => onChange(Number(e.target.value))}
  >
    {PAGE_SIZE_OPTIONS.map((size) => (
      <option key={size} value={size}>
        {size} per page
      </option>
    ))}
  </select>
)

export default PageSizeSelect
